import { ILLGenericKeys } from './index';

export class ISSDPConctact{
  xmlncontact: string;
  splTitle: string;
  majorRevision: number;
  minorRevision: number;
  workFlowStatus: number;
  contactId: string;
  contactRevisionId: string;
  firstName: string;
  lastName: string;
  fullName: string;
  phoneArea: string;
  areaCode: string;
  phoneExt: string;
  phone: string;
  altPhoneArea: string;
  altAreaCode: string;
  altPhone: string;
  altPhoneExt: string;
  email: string;
  address: string;
  city: string;
  zip: string;
  notes: string;
  country: ILLGenericKeys;
  state: string;
  companyType: ILLGenericKeys[];
  busCategory: ILLGenericKeys;
}
